import React from 'react';
import { Box, Inline } from '@atlaskit/primitives';
import Toggle from '@atlaskit/toggle';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import messages from '../../../../common/messages/pages-messages.tsx';

export type Props = {
	isEnabled: boolean;
	onEnabledChange: () => void;
	intl: IntlShape;
};

const toggleId = 'navigation-shortcuts.manage-pages-link-modal.modal.toggle';

function Content(props: Props) {
	const {
		intl: { formatMessage },
		isEnabled,
		onEnabledChange,
	} = props;
	return (
		<Inline>
			<Box as="label" htmlFor={toggleId}>
				{formatMessage(messages.enablePagesLinkText)}
			</Box>
			<Box>
				<Toggle id={toggleId} isChecked={isEnabled} onChange={onEnabledChange} />
			</Box>
		</Inline>
	);
}

export default Content;
